// import { Component, OnDestroy } from '@angular/core';
// import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
// import { Subscription } from 'rxjs';
// import { Message } from 'primeng/api';
// import { environment } from 'src/environments/environment';

// @Component({
//   selector: 'app-file-upload',
//   templateUrl: './file-upload.component.html',
//   styleUrls: ['./file-upload.component.scss']
// }) export class FileUploadComponent implements OnDestroy {
//   visible: boolean = false; // Para el modal de eliminar batch
//   selectedFile: File | null = null;
//   isUploading = false;
//   isDragging = false;
//   uploadProgress = 0;
//   uploadMessage = '';
//   uploadSuccess = false;
//   showInvalidFileError = false;
//   msjError: string | null = null;
//   lstErrores: string[] = [];
//   private uploadSub: Subscription | null = null;

//   // Nuevas propiedades para el modal de eliminar batch
//   showModalEliminar = false;
//   noBatchEliminar = '';
//   isEliminando = false;
//   modalError = '';
//   modalSuccess = '';

//   constructor(private http: HttpClient) { }

//   private isValidFileType(file: File): boolean {
//     return file.name.toLowerCase().endsWith('.csv') &&
//       (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel');
//   }

//   onDragOver(event: DragEvent) {
//     event.preventDefault();
//     event.stopPropagation();
//     this.isDragging = true;
//   }

//   onDrop(event: DragEvent) {
//     event.preventDefault();
//     event.stopPropagation();
//     this.isDragging = false;

//     const files = event.dataTransfer?.files;
//     if (files && files.length > 0) {
//       const file = files[0];
//       if (this.isValidFileType(file)) {
//         this.showInvalidFileError = false;
//         this.selectedFile = file;
//         this.uploadFile();
//       } else {
//         this.showInvalidFileError = true;
//         this.selectedFile = null;
//       }
//     }
//   }

//   onFileSelected(event: any) {
//     const file = event.target.files[0];
//     if (file && this.isValidFileType(file)) {
//       this.showInvalidFileError = false;
//       this.selectedFile = file;
//       this.uploadFile();
//     } else {
//       this.showInvalidFileError = true;
//       this.selectedFile = null;
//       event.target.value = ''; // Limpiar el input
//     }
//   }

//   uploadFile() {
//     if (!this.selectedFile) return;

//     const formData = new FormData();
//     formData.append('archivocsv', this.selectedFile);

//     this.isUploading = true;
//     this.uploadProgress = 0;
//     this.uploadMessage = '';
//     this.msjError = null;
//     this.lstErrores = [];
//     this.uploadSuccess = false;

//     this.uploadSub = this.http.post(environment.api.uplote, formData, {
//       reportProgress: true,
//       observe: 'events'
//     }).subscribe({
//       next: (event: any) => {
//         if (event.type === HttpEventType.UploadProgress) {
//           this.uploadProgress = Math.round(100 * event.loaded / event.total);
//         } else if (event.type === HttpEventType.Response) {
//           console.log('Respuesta del servidor:', event.body);

//           // Verificar si la respuesta tiene errores
//           // El backend puede devolver errores de dos formas:
//           // 1. Con propiedad 'errors' (errores de validación)
//           // 2. Con propiedad 'success' = false (errores generales)
//           // 3. Con propiedad 'success' = true (éxito)

//           if (event.body && event.body.errors && event.body.errors.length > 0) {
//             // Caso 1: Error con lista de errores
//             this.handleErrorResponse(event.body);
//           } else if (event.body && event.body.success === false) {
//             // Caso 2: Error general
//             this.handleErrorResponse(event.body);
//           } else if (event.body && event.body.success === true) {
//             // Caso 3: Éxito (tu caso actual)
//             this.uploadMessage = event.body.message || 'Archivo CSV subido exitosamente!';
//             this.uploadSuccess = true;
//             this.msjError = null;
//             this.lstErrores = [];

//             // Mostrar detalles adicionales si existen
//             if (event.body.data) {
//               console.log('Datos procesados:', event.body.data);
//             }
//           } else {
//             // Por si acaso, verificar si hay algún indicador de error
//             if (event.body && event.body.message && event.body.message.includes('error')) {
//               this.handleErrorResponse(event.body);
//             } else {
//               // Asumir éxito
//               this.uploadMessage = event.body?.message || 'Archivo procesado correctamente';
//               this.uploadSuccess = true;
//               this.msjError = null;
//               this.lstErrores = [];
//             }
//           }
//           this.isUploading = false;
//         }
//       },
//       error: (err: HttpErrorResponse) => {
//         console.error('Error en la petición:', err);
//         console.error('Error data:', err.error);

//         // Aquí el error ya viene en err.error
//         this.handleErrorResponse(err.error);
//         this.isUploading = false;
//       },
//       complete: () => {
//         console.log("completado");
//       }
//     });
//   }

//   private handleErrorResponse(errorData: any) {
//     this.uploadSuccess = false;

//     console.log('Error data recibida:', errorData); // Para debug

//     if (errorData) {
//       // El mensaje principal viene en errorData.message
//       this.msjError = errorData.message || 'Error al procesar el archivo';
//       this.uploadMessage = ''; // Asegurar que el mensaje de éxito no se muestre

//       // Los errores específicos vienen en errorData.errors
//       if (errorData.errors && Array.isArray(errorData.errors)) {
//         this.lstErrores = errorData.errors;
//       } else if (errorData.original && errorData.original.errors) {
//         // Por si acaso viene anidado en "original"
//         this.lstErrores = errorData.original.errors;
//       } else if (typeof errorData.errors === 'string') {
//         this.lstErrores = [errorData.errors];
//       } else if (errorData.message) {
//         // Si solo hay message, lo usamos como único error
//         this.lstErrores = [errorData.message];
//       } else {
//         this.lstErrores = ['Error desconocido al procesar el archivo'];
//       }
//     } else {
//       this.msjError = 'Error de conexión con el servidor';
//       this.lstErrores = ['No se pudo conectar con el servidor'];
//     }

//     console.log('msjError:', this.msjError);
//     console.log('lstErrores:', this.lstErrores);
//   }

//   // Método para abrir el modal
//   abrirModalEliminarBatch() {
//     this.showModalEliminar = true;
//     this.noBatchEliminar = '';
//     this.modalError = '';
//     this.modalSuccess = '';
//     this.isEliminando = false;
//     this.visible = true
//   }

//   // Método para cerrar el modal
//   cerrarModal() {
//     if (!this.isEliminando) {
//       this.showModalEliminar = false;
//       this.noBatchEliminar = '';
//       this.modalError = '';
//       this.modalSuccess = '';
//       this.visible = false;
//     }
//   }

//   // Método para confirmar la eliminación
//   confirmarEliminar() {
//     if (!this.noBatchEliminar || this.noBatchEliminar.trim() === '') {
//       this.modalError = 'Por favor ingrese un número de batch';
//       return;
//     }

//     this.isEliminando = true;
//     this.modalError = '';
//     this.modalSuccess = '';

//     const requestData = {
//       noBatch: this.noBatchEliminar.trim()
//     };

//     // Usar la URL directamente para pruebas
//     const url = 'http://localhost:8000/api/administradores/eliminar-batch';

//     console.log('URL a llamar:', url);

//     this.http.delete(url, { body: requestData })
//       .subscribe({
//         next: (response: any) => {
//           this.modalSuccess = response.message || 'Batch eliminado correctamente';
//           this.isEliminando = false;

//           setTimeout(() => {
//             this.cerrarModal();
//             this.uploadMessage = response.message;
//             this.uploadSuccess = true;

//             setTimeout(() => {
//               this.uploadMessage = '';
//               this.uploadSuccess = false;
//             }, 3000);
//           }, 2000);
//         },
//         error: (err: HttpErrorResponse) => {
//           console.error('Error completo:', err);
//           this.modalError = err.error?.message || 'Error al eliminar el batch';
//           if (err.error?.errors && err.error.errors.length > 0) {
//             this.modalError = err.error.errors[0];
//           }
//           this.isEliminando = false;
//         }
//       });
//   }
//   ngOnDestroy() {
//     if (this.uploadSub) {
//       this.uploadSub.unsubscribe();
//     }
//   }

//   limpiar(inputElement?: HTMLInputElement): void {
//     this.selectedFile = null;
//     this.isUploading = false;
//     this.uploadProgress = 0;
//     this.uploadMessage = '';
//     this.uploadSuccess = false;
//     this.showInvalidFileError = false;
//     this.msjError = null;
//     this.lstErrores = [];

//     if (inputElement) {
//       inputElement.value = ''; // Limpia el input de archivo
//     }
//   }

// }
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { Message } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnDestroy, OnInit {

  visible: boolean = false;
  selectedFile: File | null = null;
  isUploading = false;
  isDragging = false;
  uploadProgress = 0;
  uploadMessage = '';
  uploadSuccess = false;
  showInvalidFileError = false;
  msjError: string | null = null;
  lstErrores: string[] = [];
  private uploadSub: Subscription | null = null;

  // Modal eliminar
  showModalEliminar = false;
  noBatchEliminar = '';
  isEliminando = false;
  modalError = '';
  modalSuccess = '';

  // 🔥 NUEVO (tabla)
  batches: any[] = [];
  isLoadingBatches = false;

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.obtenerBatches();
  }

  private isValidFileType(file: File): boolean {
    return file.name.toLowerCase().endsWith('.csv') &&
      (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel');
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (this.isValidFileType(file)) {
        this.showInvalidFileError = false;
        this.selectedFile = file;
        this.uploadFile();
      } else {
        this.showInvalidFileError = true;
        this.selectedFile = null;
      }
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && this.isValidFileType(file)) {
      this.showInvalidFileError = false;
      this.selectedFile = file;
      this.uploadFile();
    } else {
      this.showInvalidFileError = true;
      this.selectedFile = null;
      event.target.value = '';
    }
  }

  uploadFile() {
    if (!this.selectedFile) return;

    const token = localStorage.getItem('token'); 

    const formData = new FormData();
    formData.append('archivocsv', this.selectedFile);

    this.isUploading = true;
    this.uploadProgress = 0;
    this.uploadMessage = '';
    this.msjError = null;
    this.lstErrores = [];
    this.uploadSuccess = false;

    this.uploadSub = this.http.post(environment.api.uplote, formData, {
      reportProgress: true,
      observe: 'events',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(100 * event.loaded / event.total);
        } else if (event.type === HttpEventType.Response) {

          if (event.body && event.body.errors && event.body.errors.length > 0) {
            this.handleErrorResponse(event.body);
          } else if (event.body && event.body.success === false) {
            this.handleErrorResponse(event.body);
          } else if (event.body && event.body.success === true) {

            this.uploadMessage = event.body.message || 'Archivo CSV subido exitosamente!';
            this.uploadSuccess = true;
            this.msjError = null;
            this.lstErrores = [];

            // 🔥 refrescar tabla
            this.obtenerBatches();

          } else {
            if (event.body && event.body.message && event.body.message.includes('error')) {
              this.handleErrorResponse(event.body);
            } else {
              this.uploadMessage = event.body?.message || 'Archivo procesado correctamente';
              this.uploadSuccess = true;
              this.msjError = null;
              this.lstErrores = [];

              this.obtenerBatches();
            }
          }
          this.isUploading = false;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.handleErrorResponse(err.error);
        this.isUploading = false;
      }
    });
  }

  private handleErrorResponse(errorData: any) {
    this.uploadSuccess = false;

    if (errorData) {
      this.msjError = errorData.message || 'Error al procesar el archivo';
      this.uploadMessage = '';

      if (errorData.errors && Array.isArray(errorData.errors)) {
        this.lstErrores = errorData.errors;
      } else if (errorData.original && errorData.original.errors) {
        this.lstErrores = errorData.original.errors;
      } else if (typeof errorData.errors === 'string') {
        this.lstErrores = [errorData.errors];
      } else if (errorData.message) {
        this.lstErrores = [errorData.message];
      } else {
        // 🔥 FIX DEL ERROR
        this.lstErrores = [this.msjError ?? 'Error desconocido al procesar el archivo'];
      }
    } else {
      this.msjError = 'Error de conexión con el servidor';
      this.lstErrores = ['No se pudo conectar con el servidor'];
    }
  }

  // 🔥 NUEVO
  obtenerBatches() {
    this.isLoadingBatches = true;

    const url = environment.api.obtenerbatches; // 'http://localhost:8000/api/administradores/batches';

    this.http.get<any>(url).subscribe({
      next: (response) => {
        this.batches = response.data || response;
        this.isLoadingBatches = false;
      },
      error: () => {
        this.isLoadingBatches = false;
      }
    });
  }

  abrirModalEliminarBatch() {
    this.showModalEliminar = true;
    this.noBatchEliminar = '';
    this.modalError = '';
    this.modalSuccess = '';
    this.isEliminando = false;
    this.visible = true;
  }

  cerrarModal() {
    if (!this.isEliminando) {
      this.showModalEliminar = false;
      this.noBatchEliminar = '';
      this.modalError = '';
      this.modalSuccess = '';
      this.visible = false;
    }
  }

  confirmarEliminar() {
    if (!this.noBatchEliminar || this.noBatchEliminar.trim() === '') {
      this.modalError = 'Por favor ingrese un número de batch';
      return;
    }

    this.isEliminando = true;
    this.modalError = '';
    this.modalSuccess = '';

    const requestData = {
      noBatch: this.noBatchEliminar.trim()
    };

    const url = environment.api.eliminarbatch; //'http://localhost:8000/api/administradores/eliminar-batch';

    const token = localStorage.getItem('token');
    
    this.http.delete(url, { body: requestData,
      headers: {
        Authorization: `Bearer ${token}`
      }   
     })
      .subscribe({
        next: (response: any) => {
          this.modalSuccess = response.message || 'Batch eliminado correctamente';
          this.isEliminando = false;

          // 🔥 refrescar tabla
          this.obtenerBatches();

          setTimeout(() => {
            this.cerrarModal();
            this.uploadMessage = response.message;
            this.uploadSuccess = true;

            setTimeout(() => {
              this.uploadMessage = '';
              this.uploadSuccess = false;
            }, 3000);
          }, 2000);
        },
        error: (err: HttpErrorResponse) => {
          this.modalError = err.error?.message || 'Error al eliminar el batch';
          if (err.error?.errors && err.error.errors.length > 0) {
            this.modalError = err.error.errors[0];
          }
          this.isEliminando = false;
        }
      });
  }

  ngOnDestroy() {
    if (this.uploadSub) {
      this.uploadSub.unsubscribe();
    }
  }

  limpiar(inputElement?: HTMLInputElement): void {
    this.selectedFile = null;
    this.isUploading = false;
    this.uploadProgress = 0;
    this.uploadMessage = '';
    this.uploadSuccess = false;
    this.showInvalidFileError = false;
    this.msjError = null;
    this.lstErrores = [];

    if (inputElement) {
      inputElement.value = '';
    }
  }
}